import React from 'react';
import GameDevelopersState from './gameDevelopersState/GameDevelopersState';
import GameDevelopersControlPanel from './components/GameDevelopersControlPanel/GameDevelopersControlPanel';
import GameDevelopers from './components/GameDevelopers/GameDevelopers';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const GameDevelopersPage: React.FC = () => {
	return (
		<GameDevelopersState>
			<div className={style.container} data-test="GameDevelopersPage">
				<GameDevelopersControlPanel />
				<GameDevelopers />
				<ModalWindows />
			</div>
		</GameDevelopersState>
	);
};

export default GameDevelopersPage;
